(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('lodash')
        );

    } else {
        RivalIQ.module('metrics.new.validation', function (validation) {
            validation.validateListeningFilters = exportFn(_);
        });
    }

    function exportFn(_) {

        const MAX_TERMS = 50;
        const MAX_TERM_LENGTH = 200;


        function normalizeTerm(term) {
            if (term) {
                return term.toString().trim().toLowerCase();
            }
        }

        function isQuotedTerm(term) {
            const isQuoted = (term && term[0] === '"' && term[term.length - 1] === '"');
            return isQuoted;
        }

        function isDoubleQuotedTerm(term) {
            return Boolean(isQuotedTerm(term) && isQuotedTerm(unquoteTerm(term)));
        }

        function unquoteTerm(term) {
            if (isQuotedTerm(term)) {
                const unquotedTerm = term.slice(1, term.length - 1);
                return unquotedTerm;
            }
        }

        function unquoteTermOrTerm(term) {
            if (!isQuotedTerm(term)) {
                return term;
            }

            return unquoteTermOrTerm(unquoteTerm(term));
        }

        function makeTermToEarliestIdxMap(termsArray) {
            const termToEarliestIdx = _.reduceRight(termsArray, (memo, term, idx) => {
                memo[normalizeTerm(term)] = idx;
                return memo;
            }, {});
            return termToEarliestIdx;
        }

        function makeTermForErrorStrings(term) {
            const maxWidth = 30;
            term = normalizeTerm(term);
            if (_.size(term) > maxWidth + 3) {
                term = `${term.slice(0, maxWidth)}...`;
            }
            return term;
        }

        function isMiddleWildcardFormat(str) {
            // examples: "milk * drink", "apple pie * milk tea"
            const match = str.match(/^[^*]+ [*] [^*]+$/);
            return (match !== null);
        }

        function removeLeadingSpecialSymbol(str) {
            if (_.startsWith(str, '@') || _.startsWith(str, '#')) {
                return str.substring(1);
            }
            return str;
        }

        function validateTerms(termsArray, groupPath) {

            const errors = [];

            _.each(termsArray, (term, idx) => {
                if (term.length > MAX_TERM_LENGTH) {
                    errors.push({
                        idx: idx,
                        isFatal: true,
                        message: `Each term can contain a maximum of ${MAX_TERM_LENGTH} characters.`
                    });
                }
            });

            const termToEarliestIdx = makeTermToEarliestIdxMap(termsArray);

            _.each(termsArray, (term, idx) => {
                const normalTerm = normalizeTerm(term);
                const termForErrorStrings = makeTermForErrorStrings(term);

                if (_.isEmpty(_.trim(unquoteTermOrTerm(normalTerm)))) {
                    errors.push({
                        idx: idx,
                        isFatal: true,
                        message: 'Terms cannot be empty.'
                    });

                    return;
                }

                const isQuoted = isQuotedTerm(normalTerm);
                const isDoubleQuoted = isDoubleQuotedTerm(normalTerm);

                // make sure this term was not already in the list
                if (termToEarliestIdx[normalTerm] !== idx) {
                    const errorMessage = `[${termForErrorStrings}] has already been entered. ${!_.isFinite(termToEarliestIdx[term]) ? 'Capitalization does not impact search.' : ''}`.trim();
                    errors.push({
                        idx: idx,
                        isFatal: true,
                        message: errorMessage,
                        otherOccurrencePath: `${groupPath}.${termToEarliestIdx[normalTerm]}`
                    });
                    errors.push({
                        idx: termToEarliestIdx[normalTerm],
                        isFatal: true,
                        message: errorMessage,
                        otherOccurrencePath: `${groupPath}.${idx}`
                    });
                }

                // terms with an asterisk must be quoted or left paren must be quoted
                const hasAsterisk = _.includes(normalTerm, '*');
                const hasLeftParen = _.includes(normalTerm, '(');
                if (hasAsterisk || hasLeftParen) {
                    if (!isQuoted && hasAsterisk) {

                        const startsWithAsterisk = normalTerm[0] === '*';
                        if (startsWithAsterisk) {
                            errors.push({
                                idx: idx,
                                isFatal: true,
                                message: `[${termForErrorStrings}] Wildcards [*] are not supported at the beginning of a term.`
                            });
                        } else {
                            if (hasAsteriskInMiddle(removeLeadingSpecialSymbol(normalTerm))) {
                                if (isMiddleWildcardFormat(normalTerm)) {
                                    // we would allow it, but we don't tell our customer to use it, because it's too advanced and complicated
                                } else {
                                    errors.push({
                                        idx: idx,
                                        isFatal: true,
                                        message: `[${termForErrorStrings}] Wildcards [*] are not supported in the middle of a term.`
                                    });
                                }
                            }
                            const normalTermWithoutAsterisk = normalTerm.replace(/\*|\#|\@/g, '');
                            if (normalTermWithoutAsterisk.length < 3) {
                                errors.push({
                                    idx: idx,
                                    isFatal: true,
                                    message: `[${termForErrorStrings}] Terms with wildcards [*] must be at least 3 characters long.`
                                });
                            }
                        }
                    }

                    if (!isQuoted && hasLeftParen) {
                        errors.push({
                            idx: idx,
                            isFatal: true,
                            message: `[${termForErrorStrings}] groupings are not supported.`
                        });
                    }
                }

                // things that look like booleans are not allowed.
                if (!isQuoted) {
                    // NOTE: specifically not using normalizeTerm here because we want to preserve the case of the term
                    const tokens = term.split(/\s+/);
                    const booleanTerms = _.intersection(tokens, ['AND', 'OR', 'NOT']);
                    if (!_.isEmpty(booleanTerms)) {
                        errors.push({
                            idx: idx,
                            isFatal: true,
                            message: `[${termForErrorStrings}] You cannot specify Boolean expressions.`,
                            additionalInfo: 'Copy and Support syntax documentation link TBD.'
                        });
                    }
                }

                // double quoted terms may negatively impact your search results
                if (isDoubleQuoted) {
                    errors.push({
                        idx: idx,
                        isFatal: false,
                        message: `[${termForErrorStrings}] Use quotation marks ["quotation marks"] for an exact match. Use double quotation marks [""double quotation marks""] to find your key term in quotation marks.`
                    });
                }
            });

            return errors;
        }

        function addPathAndSortErrors(errors, groupPath) {
            return _(errors)
                .compact()
                .map(error => {
                    if (_.isFinite(error.idx)) {
                        error.path = `${groupPath}.${error.idx}`;
                    } else {
                        error.path = groupPath;
                    }
                    error.group = groupPath;
                    return error;
                })
                .sortBy(error => (_.isFinite(error.idx) ? error.idx : -1))
                .value();
        }

        function repeatedTermIndexes(terms, normalizedTermsToIdx, shouldCheckUnquoted = true) {

            return _(terms)
                .map((term, idx) => {
                    const normalizedTerm = normalizeTerm(term);
                    const existingIdx = normalizedTermsToIdx[normalizedTerm];
                    if (_.isFinite(existingIdx)) {
                        return {
                            index: idx,
                            existingIdx: existingIdx
                        };
                    }

                    if (shouldCheckUnquoted) {
                        const existingUnquotedIdx = normalizedTermsToIdx[unquoteTerm(normalizedTerm)];
                        if (_.isFinite(existingUnquotedIdx)) {
                            return {
                                index: idx,
                                existingIdx: existingUnquotedIdx
                            };
                        }
                    }
                })
                .compact()
                .value();
        }

        function hasAsteriskInMiddle(str) {
            const match = str.match(/^[*]?(?<middlePart>.*?)[*]?$/);
            const middlePart = match.groups.middlePart;
            return _.includes(middlePart, '*');
        }

        function validateAuthors(authors) {
            const errors = [];

            _.each(authors, (author, idx) => {
                author = normalizeTerm(author);

                if (author.length > MAX_TERM_LENGTH) {
                    errors.push({
                        idx: idx,
                        isFatal: true,
                        message: `Each author can contain a maximum of ${MAX_TERM_LENGTH} characters.`
                    });
                }

                if (_.isEmpty(author) || author === ':') {
                    errors.push({
                        idx: idx,
                        isFatal: true,
                        message: 'Author cannot be empty.'
                    });
                }

                if (_.includes(author, '*')) {
                    const authorWithoutSpecialChars = author.replace(/\*|\@/g, '');
                    if (authorWithoutSpecialChars.length < 3) {
                        errors.push({
                            idx: idx,
                            isFatal: true,
                            message: `[${authors[idx]}] Authors with wildcards [*] must be at least 3 characters long.`
                        });
                    } else if (hasAsteriskInMiddle(author)) {
                        errors.push({
                            idx: idx,
                            isFatal: true,
                            message: `[${authors[idx]}] Excluded authors can only have wildcards [*] at the beginning or end of a term.`
                        });
                    }
                }
            });

            const normalizedAuthorsToIdx = makeTermToEarliestIdxMap(authors);

            const repeatedAuthors = repeatedTermIndexes(authors, normalizedAuthorsToIdx);
            _.each(repeatedAuthors, ({index, existingIdx}) => {
                if (index === existingIdx) {
                    return;
                }
                errors.push({
                    idx: index,
                    isFatal: true,
                    message: `[${authors[index]}] has already been entered.`,
                    otherOccurrencePath: `authors.${existingIdx}`
                });
                errors.push({
                    idx: existingIdx,
                    isFatal: true,
                    message: `[${authors[index]}] has already been entered.`,
                    otherOccurrencePath: `authors.${index}`
                });
            });

            return errors;
        }

        function validateDomains(listeningFilters) {
            const domainErrors = [];
            const excludeDomainErrors = [];

            const normalizedDomainsToIdx = makeTermToEarliestIdxMap(listeningFilters.domain);
            const normalizedExcludeDomainsToIdx = makeTermToEarliestIdxMap(listeningFilters.excludeDomain);

            const repeatedDomains = repeatedTermIndexes(listeningFilters.domain, normalizedDomainsToIdx);
            _.each(repeatedDomains, ({index, existingIdx}) => {
                if (index === existingIdx) {
                    return;
                }
                domainErrors.push({
                    idx: index,
                    isFatal: true,
                    message: `[${listeningFilters.domain[index]}] has already been entered.`,
                    otherOccurrencePath: `domain.${existingIdx}`
                });
                domainErrors.push({
                    idx: existingIdx,
                    isFatal: true,
                    message: `[${listeningFilters.domain[index]}] has already been entered.`,
                    otherOccurrencePath: `domain.${index}`
                });
            });

            const repeatedExcludeDomains = repeatedTermIndexes(listeningFilters.excludeDomain, normalizedExcludeDomainsToIdx);
            _.each(repeatedExcludeDomains, ({index, existingIdx}) => {
                if (index === existingIdx) {
                    return;
                }
                excludeDomainErrors.push({
                    idx: index,
                    isFatal: true,
                    message: `[${listeningFilters.excludeDomain[index]}] has already been entered.`,
                    otherOccurrencePath: `excludeDomain.${existingIdx}`
                });
                excludeDomainErrors.push({
                    idx: existingIdx,
                    isFatal: true,
                    message: `[${listeningFilters.excludeDomain[index]}] has already been entered.`,
                    otherOccurrencePath: `excludeDomain.${index}`
                });
            });

            _.each(listeningFilters.domain, (domain, idx) => {
                domain = normalizeTerm(domain);
                if (!domain) {
                    domainErrors.push({
                        idx: idx,
                        isFatal: true,
                        message: 'Domain cannot be empty.'
                    });
                }

                if (_.isFinite(normalizedExcludeDomainsToIdx[domain])) {
                    domainErrors.push({
                        idx: idx,
                        isFatal: true,
                        message: `[${domain}] is already in the exclude list.`,
                        otherOccurrencePath: `excludeDomain.${normalizedExcludeDomainsToIdx[domain]}`
                    });
                    excludeDomainErrors.push({
                        idx: normalizedExcludeDomainsToIdx[domain],
                        isFatal: true,
                        message: `[${domain}] is already in the include list.`,
                        otherOccurrencePath: `domain.${idx}`
                    });
                }
            });

            _.each(listeningFilters.excludeDomain, (domain, idx) => {
                domain = normalizeTerm(domain);
                if (!domain) {
                    excludeDomainErrors.push({
                        idx: idx,
                        isFatal: true,
                        message: 'Domain cannot be empty.'
                    });
                }
            });

            _.each(listeningFilters.excludeDomain, (domain, idx) => {
                if (_.includes(domain, '*')) {
                    excludeDomainErrors.push({
                        idx: idx,
                        isFatal: true,
                        message: `[${domain}] Excluded domains cannot contain wildcards.`
                    });
                }

                if (domain.length > MAX_TERM_LENGTH) {
                    excludeDomainErrors.push({
                        idx: idx,
                        isFatal: true,
                        message: `Each excluded domain can contain a maximum of ${MAX_TERM_LENGTH} characters.`
                    });
                }
            });

            return {
                domain: domainErrors,
                excludeDomain: excludeDomainErrors
            };
        }

        function validateListeningFilters(listeningFilters) {
            const allErrors = {
                searchTerms: [],
                searchTermsAnd: [],
                searchTermsNot: []
            };

            const numPrimaryTerms = _.size(listeningFilters.searchTerms);
            if (numPrimaryTerms > MAX_TERMS) {
                allErrors.searchTerms.push({
                    idx: numPrimaryTerms - 1,
                    isFatal: true,
                    message: `You can only add up to ${MAX_TERMS} primary search terms.`
                });
            } else if (numPrimaryTerms === 0) {
                allErrors.searchTerms.push({
                    isFatal: true,
                    message: `You must specify as least one primary search term.`
                });
            }

            allErrors.searchTerms = allErrors.searchTerms.concat(validateTerms(listeningFilters.searchTerms, 'searchTerms'));

            const normalizedSearchTermsToIdx = makeTermToEarliestIdxMap(listeningFilters.searchTerms);
            const normalizedSearchTermsNotToIdx = makeTermToEarliestIdxMap(listeningFilters.searchTermsNot);

            _.each(listeningFilters.searchTermsAnd, (andGroup, andGroupIdx) => {
                if (_.isEmpty(andGroup)) {
                    return;
                }

                const termDescription = (andGroupIdx === 0 ? 'an included' : ' a narrowing');

                allErrors.searchTermsAnd[andGroupIdx] = validateTerms(andGroup, `searchTermsAnd.${andGroupIdx}`);

                const excludeTermDupeIndexes = repeatedTermIndexes(andGroup, normalizedSearchTermsNotToIdx, false);
                _.each(excludeTermDupeIndexes, ({index, existingIdx}) => {
                    allErrors.searchTermsAnd[andGroupIdx].push({
                        idx: index,
                        isFatal: true,
                        message: `[${andGroup[index]}] cannot be ${termDescription} and an excluded term.`,
                        otherOccurrencePath: `searchTermsNot.${existingIdx}`
                    });

                    allErrors.searchTermsNot.push({
                        idx: existingIdx,
                        isFatal: true,
                        message: `[${listeningFilters.searchTermsNot[existingIdx]}] cannot be an excluded term and ${termDescription} term.`,
                        otherOccurrencePath: `searchTermsAnd.${andGroupIdx}.${index}`
                    });
                });

                // NBQ errors if a part of the term is one of the excluded terms too. E.g, if a term is "foo bar" and "bar" is excluded, then
                // the term is invalid.
                const repeatedSubTerms = _.flatMap(andGroup, (term, idx) => {
                    const normalizedTerm = normalizeTerm(term);

                    const termParts = normalizedTerm.split(/\s+/);
                    if (termParts.length < 2) {
                        return [];
                    }

                    return _(termParts)
                        .map(termPart => {
                            const existingIdx = normalizedSearchTermsNotToIdx[termPart];
                            if (_.isFinite(existingIdx)) {
                                return {
                                    index: idx,
                                    existingIdx: existingIdx,
                                    termPart: termPart
                                };
                            }

                            const existingUnquotedIdx = normalizedSearchTermsNotToIdx[unquoteTerm(termPart)];
                            if (_.isFinite(existingUnquotedIdx)) {
                                return {
                                    index: idx,
                                    existingIdx: existingUnquotedIdx
                                };
                            }
                        })
                        .compact()
                        .value();
                });

                _.each(repeatedSubTerms, ({index, existingIdx, termPart}) => {
                    allErrors.searchTermsAnd[andGroupIdx].push({
                        idx: index,
                        isFatal: true,
                        message: `[${termPart}] cannot be ${termDescription} and an excluded term.`,
                        otherOccurrencePath: `searchTermsNot.${existingIdx}`
                    });

                    allErrors.searchTermsNot.push({
                        idx: existingIdx,
                        isFatal: true,
                        message: `[${listeningFilters.searchTermsNot[existingIdx]}] cannot be an excluded term and ${termDescription} term.`,
                        otherOccurrencePath: `searchTermsAnd.${andGroupIdx}.${index}`
                    });
                });
            });

            allErrors.searchTermsNot = allErrors.searchTermsNot.concat(validateTerms(listeningFilters.searchTermsNot, 'searchTermsNot'));

            const primaryTermDupeIndexes = repeatedTermIndexes(listeningFilters.searchTermsNot, normalizedSearchTermsToIdx, false);
            _.each(primaryTermDupeIndexes, ({index, existingIdx}) => {
                allErrors.searchTermsNot.push({
                    idx: index,
                    isFatal: true,
                    message: `[${listeningFilters.searchTermsNot}] is a primary term and cannot be added here.`,
                    otherOccurrencePath: `searchTerms.${existingIdx}`
                });

                allErrors.searchTerms.push({
                    idx: existingIdx,
                    isFatal: true,
                    message: `[${listeningFilters.searchTerms[existingIdx]}] cannot be an excluded term and a primary term.`,
                    otherOccurrencePath: `searchTermsNot.${index}`
                });
            });

            const {domain, excludeDomain} = validateDomains(listeningFilters);

            // sort all the groups and add path info where applicable
            allErrors.searchTerms = addPathAndSortErrors(allErrors.searchTerms, 'searchTerms');
            allErrors.searchTermsAnd = _.map(allErrors.searchTermsAnd, (searchTermsAnd, groupIndex) => addPathAndSortErrors(searchTermsAnd, `searchTermsAnd.${groupIndex}`));
            allErrors.searchTermsNot = addPathAndSortErrors(allErrors.searchTermsNot, 'searchTermsNot');
            allErrors.excludeAuthor = addPathAndSortErrors(validateAuthors(listeningFilters.excludeAuthor), 'excludeAuthor');
            allErrors.domain = addPathAndSortErrors(domain, 'domain');
            allErrors.excludeDomain = addPathAndSortErrors(excludeDomain, 'excludeDomain');

            const hasErrors = _.some(allErrors, errorSet => !_.isEmpty(_.flatten(_.compact(errorSet))));

            return hasErrors ? allErrors : null;
        }

        return validateListeningFilters;
    }
})();
